import { Icon } from "@garantidos/components"

import If from "@mobi/components/If"
import Button from "@mobi/ds/components/Button"
import Modal from "@mobi/ds/components/Modal"
import Text from "@mobi/ds/components/Text"

import faqImage from "./images/faqimage.png"

import useYouTubeVideo from "./hooks"

import "./style.scss"

const YouTubeVideo = ({
  videoLink = "",
  videoTitle = "",
  videoThumbnail = "",
  videoTranscription = "",
  videoTitleAriaLabel = "",
  position = "left",
  className = "",
  imageClassName = "",
  clickTracking = {},
  ...props
}) => {
  const {
    playerOpen,
    transcriptionOpen,
    handleVideoClick,
    handleTranscriptionClick,
  } = useYouTubeVideo({ clickTracking })
  return (
    <If
      condition={!!videoLink}
      renderIf={
        <>
          <div className="youtubeWrapper__imageContainer">
            <div
              className={`youtubeWrapper__image youtubeWrapper__image--${position} ${imageClassName}`}
            >
              <img
                src={faqImage}
                className={`youtubeWrapper__image youtubeWrapper__image--${position} ${imageClassName}`}
                alt="Casal se olhando em um fundo azul"
                aria-hidden
              />
            </div>
            <button
              type="button"
              className="youtubeWrapper__playButton"
              aria-label={`play em ${videoTitleAriaLabel}`}
              onClick={() => handleVideoClick(true)}
            >
              <Icon
                icon="play"
                width={24}
                height={24}
                className="youtubeWrapper__icon"
              />
            </button>
            <If
              condition={!!videoTranscription}
              renderIf={
                <Button
                  variant="action"
                  className="youtubeWrapper__caption"
                  aria-label={`Transcrição do vídeo`}
                  onClick={() => handleTranscriptionClick(true)}
                >
                  transcrição
                </Button>
              }
            />
          </div>
          <Modal
            type="center"
            show={playerOpen}
            onCloseClick={() => handleVideoClick(false)}
          >
            <div className={`youtubeWrapper ${className}`}>
              <iframe
                src={videoLink}
                title={videoTitle}
                aria-label={`Reprodutor incorporado de vídeos do Youtube. Vídeo: ${videoTitle}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                {...props}
              />
            </div>
          </Modal>
          <Modal
            type="pop"
            show={transcriptionOpen}
            onCloseClick={() => handleTranscriptionClick(false)}
          >
            <Text as="p" className="youtubeWrapper__transcriptionTitle">
              {videoTitle}
            </Text>
            <Text as="p" className="youtubeWrapper__transcriptionText">
              {videoTranscription}
            </Text>
          </Modal>
        </>
      }
    />
  )
}

export default YouTubeVideo
